import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppConfig, AppConfigKeys } from '../app.config';
import { AuthService } from '../core/auth';

@Injectable()
export class LoginService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private appConfig: AppConfig,
        private authService: AuthService
    ) {
        this.apiUrl = this.appConfig.get(AppConfigKeys.ApiUrl);

        this.UserData = new BehaviorSubject<UserData>(
            JSON.parse(localStorage.getItem('currentUD'))
        );
    }

    public UserData: BehaviorSubject<UserData>;

    postLogin(req: LoginRequest): Promise<any> {
        const url: string = this.apiUrl + 'Login';
        this.authService.clearToken();

        return this.http
            .post(url, req, { observe: 'response' })
            .toPromise()
            .then((res) => this.loginResponse(res));
        //.catch(this.E.error);
    }

    loginWithAzureToken(token: string): Promise<any> {
        //TODO login validation
        /*return this.http.post<FMITUserObj>(`/api/auth/azure`, { "token": token })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentFMITUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    return user;
                }

                throw new Error("Bad Login");
            })).toPromise()
            ;*/

        let req: LoginRequest = {
            token: token,
        };
        const url: string = this.apiUrl + 'LoginAzure';
        this.authService.clearToken();

        return this.http
            .post(url, req, { observe: 'response' })
            .toPromise()
            .then((res) => this.loginResponse(res));
    }

    loginWithGoogleToken(token: string): Promise<any> {
        let req: LoginRequest = {
            token: token,
        };
        const url: string = this.apiUrl + 'LoginGoogle';
        this.authService.clearToken();

        return this.http
            .post(url, req, { observe: 'response' })
            .toPromise()
            .then((res) => this.loginResponse(res));
    }

    loginResponse(res: HttpResponse<any>) {
        if (res.body && res.body.token) {
            this.authService.setToken(res.body.token);
            localStorage.setItem('currentUD', JSON.stringify(res.body));
            this.UserData.next(res.body as UserData);
        }
    }

    resetPassword(username: string): Promise<any> {
        const url: string = this.apiUrl + 'ResetPassword?username=' + username;
        return this.http
            .get(url)
            .toPromise()
            .then((res) => res);
    }

    getSiteParams(): Observable<SiteParams> {
        const url: string = this.apiUrl + 'GetSiteData';

        return this.http.get<SiteParams>(url);
    }
}

export class LoginRequest {
    public token: string;
}
export class SiteParams {
    GoogleAuthEnabled: boolean;
    MicrosoftAuthEnabled: boolean;
    BannerUrl: string;
}

export class UserData {
    firstName: string;
    lastName: string;
}
